/* Functions to standardize display of student information from Shared Portal (Explore) Students */

export const renderApplyYear = (student) => {
  const year = student.apply_year;
  if (year) {
    return `${year}-${year + 1}`;
  }
  return null;
};

export const renderApplyGrade = (student) => `${student.apply_grade} Grade`;

export const renderStudentName = (student) => `${student.first_name} ${student.last_name}`;
